var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('City',{attrs:{"label":_vm.$$t('City', 'label'),"country":_vm.currentCountryData},model:{value:(_vm.accountCity),callback:function ($$v) {_vm.accountCity=$$v},expression:"accountCity"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }